import { autoinject } from "aurelia-framework";
import { RatingsSummaryModel } from "../models/due-diligence.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
export class SafetyRatingApi {

    private safetyRatingApiUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/SafetyRating`;

    constructor(private requestClient: RequestClientService, private configService: ConfigService){}

    //Get vessel ratings
    public getRatingsModel(vesselId: number): Promise<RatingsSummaryModel> {
        return this.requestClient.get(`${this.safetyRatingApiUrl}/GetRatingsModel/${vesselId}`, {});
    }
}